import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SearchComponent} from './views/search/search.component';
import {EstimateComponent} from './views/estimate/estimate.component';
import {NeighborsComponent} from './views/neighbors/neighbors.component';
import {PerformanceComponent} from './views/performance/performance.component';
import {SearchArtistsComponent} from './views/search-artists/search-artists.component';
import {SearchArtworksComponent} from './views/search-artworks/search-artworks.component';


const routes: Routes = [
  { path: '',   redirectTo: '/search/artists', pathMatch: 'full' },
  { path: 'search/artists', component: SearchArtistsComponent },
  { path: 'search/artworks/:artistId', component: SearchArtworksComponent },
  { path: 'search', component: SearchComponent },
  { path: 'estimate', component: EstimateComponent },
  { path: 'neighbors', component: NeighborsComponent },
  { path: 'performance', component: PerformanceComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
